import React, { useState } from "react";
import { EditableTextField } from "../../../../Global_Component/CustomInputComponent";
import { CustomFileUpload } from "../../../../Global_Component/customFileUplodComponent";
import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  InputLabel,
} from "@mui/material";
import { CustomSecondaryButton, CustomSuccessButton } from "../../../../Global_Component/GlobalButtonComponent";

const CorrespondaceProfile = ({MoveToNextTab,MoveToPreviousTab}) => {
  const [uploadedFiles, setUploadedFiles] = useState({});

  const handleFileUpload = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFiles((prev) => ({ ...prev, [key]: file.name }));
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",
      
        borderRadius: "8px",
        backgroundColor: "#fff",
        height:"100%",
      
        
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#333" }}
      >
        Company details
      </Typography>

      <Grid
        container
        sm={12}
        md={12}
        lg={8}
        xl={9}
        spacing={0}
      >
       

        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"First Name"} name={"firstName"} value={"Enter Here"} isEdit={true}/>
        </Grid>

        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Last Name"} name='lastName' value={"Enter Here"} isEdit={true}/>
        </Grid>

        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Designation"} name={'designation'} value={"Enter Here"} isEdit={true}/>
        </Grid>
       
        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Contact Number (Phone)"} value={"Enter Here"} isEdit={true}/>
        </Grid>


        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Contact Number (Landline)"} value={"Enter Here"} isEdit={true}/>
        </Grid>


        <Grid item md={6} sx={{p:1,m:0}}>
        <EditableTextField label={"Email"} name={"email"} value={"Enter Here"} isEdit={true}/>
        </Grid>
      </Grid>

     <Grid xs={12} sx={{display:"flex",alignItems:"center",justifyContent:"flex-end",gap:1}}>
      <CustomSecondaryButton label={"Back"} sx={{margin:2}} onClick={e=>MoveToPreviousTab()} />
        <CustomSuccessButton label={"Next"} onClick={e=>MoveToNextTab()}/>
     </Grid>
    </Box>
  );
};

export default CorrespondaceProfile;
